import router from "./index";

export default [{
  path: "/ClubSelect",
  component: () => import('../views/ClubSelect/ClubSelect'),
  beforeEnter: (to, from, next) => {
    if (router.app.$cookies.get("user") === "student")
      next();
    else
      router.replace("/home");
  },
  meta: {
    title: '选择俱乐部'
  },
  children: [
    {
      path: '/',
      redirect: 'ClubSelectList'
    },
    {
      path: 'ClubSelectList',
      component: () => import('../views/ClubSelect/ClubSelectList/ClubSelectList'),
      meta: {
        title: '俱乐部列表'
      },
    },
    {
      path: 'ClubDetail',
      component: () => import('../views/ClubSelect/ClubDetail/ClubDetail'),
      meta: {
        title: '俱乐部详细'
      },
    },
  ]
},]
